/**
 * FS Options
 *
 * Represents a configuration object used to store options for a specific functionality or process.
 * If the variable is uninitialized or falsy, it defaults to an empty object.
 * This ensures that the variable always has a valid object to hold key-value pairs of options.
 */

var __fast_options = __fast_options || {};
__fast_options.disable_ac_shadow_root = true;
window.pdpData = {};

class FSCustom {

  constructor() {
    this.timeout = null;

    // Set a global variable for login status using Liquid
    this.customerData = {}

    this.fsProductPricing = {};
    this.fetchingSaleTag = false;
  }

  init() {
    let _this = this;

    this.customerData = Object.assign(window.customerData, {
      tagsString: null,
      tiername: null
    });

    this.bindEvents();
    this.formatTags();


    // execution here
    if (window.SerpOptions) {
      _this.plpHooks();
    } else {
      window.addEventListener('fast-serp-ready', function () {
        _this.plpHooks();
      });
    }

    if (window.FastAutocomplete) {
      _this.autocompleteHooks();
    } else {
      window.addEventListener('fast-autocomplete-ready', function () {
        _this.autocompleteHooks();
      });
    }
  }

  bindEvents() {
    let _this = this;
  }

  /**
   * Registers various hooks for updating or modifying the UI elements in specific components such as
   * product grids, top-page options, and product swatches.
   *
   * The hooks manipulate DOM elements to enhance or customize the display and interaction
   * with product reviews, sorting options, and color swatches.
   *
   * The following hooks are registered:
   * - `serp-product-grid`: Enhances product grid items with additional review count and formatting for review averages.
   * - `serp-top-page`: Adds a 'Sort By' label to the sorting dropdown UI if it doesn't already exist.
   * - `serp-product-swatches`: Adds additional functionality and elements to color swatch UI based on the number of available color variations.
   *
   * @return {void} No return value. The function alters DOM elements directly.
   */
  plpHooks() {
    let _this = this;

    window.addEventListener('fs-custom-events-product-swatch-on-click', (e) => {
      setTimeout(() => {
        let pricingData = _this.fsProductPricing[e.detail.parentID];
        if (pricingData) {
          let priceContainer = pricingData.element.querySelector('.price-container.fs-serp-price .price');
          let compareContainer = pricingData.element.querySelector('.compare-container .compare.fs-compare');
          if (priceContainer) {
            priceContainer.innerText = pricingData.price;
          }
          if (compareContainer && pricingData.compareText) {
            compareContainer.innerText = pricingData.compareText;
          }
        }
      }, 5);
    });

    window.SerpOptions.registerHook('serp-main-block', (e) => {

      e.element.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (!event.target.classList.contains('monogram-icon-container') && !event.target.closest('.monogram-icon-container')) {
          if (typeof e.element != "undefined" && e.element.querySelector('.monogram-inner-container.active')) {
            _this.clearTooltips(e.element);
          }
        }
      })
    });

    window.SerpOptions.registerHook("serp-product-grid", ({products, element}) => {
      _this.updateSearchPageTitle(element);
      // Loop products
      for (const [productId, product] of Object.entries(products)) {
        let productElement = element.querySelector(`[data-product-id="${productId}"]`);
        if (productElement) {
          _this.updateReviewsCountText(product, productElement);
          _this.addComparePriceToProductBlocks(product, productId, productElement);
          _this.addMonogramIcon(product, productElement);
          _this.addSaleTag(product, productId, productElement);

          // update B2B Prices
          let productURL = product.productURL || '';
          if (!window.pdpData[productId]) {
            window.pdpData[productId] = "notFetched";
          }
          _this.setProductSpecialPrice(productElement, productId, productURL, _this.customerData.tiername);

          // hide promo tiles
          element.querySelectorAll('.fs-promo-tile-product-wrapper').forEach(el => {
            el.style.display = 'none';
          });
        }
      }

    });

    window.SerpOptions.registerHook("serp-top-page", ({element}) => {
      setTimeout(() => {

        let wrapper = element.querySelector('.fs-select-wrapper');

        if (wrapper && !wrapper.querySelector('.fs-select-label')) {
          let label = document.createElement("div");
          label.classList.add('fs-select-label');
          label.innerText = 'Sort By:';
          wrapper.appendChild(label);
        }
      }, 250)
    });

    window.SerpOptions.registerHook("serp-filters", ({facets, element}) => {
      element.querySelectorAll('.color-swatch-container:not(.ele-bound)').forEach((ele) => {
        ele.addEventListener('click', (e) => {
          if (e.target.classList.contains('color-swatch-container') && !e.target.classList.contains('color-swatch')) {
            if (ele.querySelector('.color-swatch')) {
              ele.querySelector('.color-swatch').click();
            }
          }
        });
        ele.classList.add('ele-bound');
      });
    });

    window.SerpOptions.registerHook("serp-product-swatches", ({colors, swatchClick, showMoreClick, element}) => {

      let listEl = element.querySelector('.color-swatches');

      if (colors.length > 6 && !listEl.querySelector('.color-swatch-extra-colors')) {
        let extraColorsLength = colors.length - 6;
        let extraColorsText = extraColorsLength === 1 ? 'color' : 'colors';
        let text = `+ ${extraColorsLength} ${extraColorsText}`;

        let link = element.closest('.product-card').querySelector('.title-container').getAttribute('href');

        let colorsCountEl = document.createElement("a");
        colorsCountEl.classList.add('color-swatch-extra-colors');
        colorsCountEl.innerText = text;
        colorsCountEl.setAttribute('href', link);
        colorsCountEl.setAttribute('tabindex', '0');
        colorsCountEl.setAttribute('role', 'button');
        colorsCountEl.setAttribute('aria-label', text);
        listEl.appendChild(colorsCountEl);
      }

      setTimeout(function () {
        if (colors.length === 1 && listEl.querySelectorAll('.color-swatch-container').length < 1) {

          let resultClass = '';
          let randomSwatchEl = element.closest('.searchResultsWrapper').querySelector('.color-swatch');

          if (randomSwatchEl) {
            randomSwatchEl.classList.forEach((className) => {
              if (className.indexOf('fs-result-page-') > -1) {
                resultClass = className;
              }
            });
          }

          let color = colors[0];
          let swatchContainer = document.createElement("span");
          swatchContainer.classList.add('color-swatch-container');
          swatchContainer.classList.add('fs-color-swatch-container');
          swatchContainer.setAttribute('tabindex', '0');
          swatchContainer.setAttribute('role', 'button');
          swatchContainer.setAttribute('aria-label', `; Variant: ${color.value}`);

          let colorHandle = color.value.toLowerCase().replace(/\s/g, '-');

          let swatchElement = document.createElement("span");
          swatchElement.classList.add('color-swatch');
          swatchElement.classList.add('fast-swatch-color-fallback');
          swatchElement.classList.add(`fast-swatch-color-${colorHandle}`);
          swatchElement.classList.add(`isp-product-color-swatch-${colorHandle}`);
          if (resultClass) {
            swatchElement.classList.add(resultClass);
          }
          swatchElement.setAttribute('data-disabled', 'false');
          swatchElement.setAttribute('style', '--swatch-width:25px;--swatch-height:25px');
          //swatchElement.setAttribute('title', color.value);
          swatchElement.addEventListener('click', swatchClick);

          swatchContainer.appendChild(swatchElement);
          listEl.appendChild(swatchContainer);
        }
      }, 1)
    });

  }

  /**
   * Registers a hook to customize the rendering of autocomplete product items.
   * This method modifies the product item's HTML by injecting additional review and rating data.
   * The function initializes elements needed for displaying Yotpo reviews and processes them asynchronously.
   *
   * @return {void} This function does not return any value.
   */
  autocompleteHooks() {
    let _this = this;

    window.FastAutocomplete.registerHook('render-autocomplete-product-item', ({product, index, element}) => {

      if(document.body.dataset.priceRangesInAutocomplete && document.body.dataset.priceRangesInAutocomplete === "true") {
        if (product.p_max && product.p_min && product.p_max !== product.p_min) {
          const priceWrapper = element.querySelector('.price.fs-product-price-wrapper');
          if (priceWrapper) {
            const actualPriceSpan = priceWrapper.querySelector('.actual-price');
            const comparePriceSpan = priceWrapper.querySelector('.compare');

            // Update the main price to show a range.
            if (actualPriceSpan) {
              const priceRangeText = `$${product.p_min} - $${product.p_max}`;
              actualPriceSpan.innerText = priceRangeText;
              actualPriceSpan.setAttribute('aria-label', `; price: ${priceRangeText}`);
            }

            // If a compare-at price exists, update it to show a range as well.
            if (comparePriceSpan) {
              // Determine the correct min and max compare-at prices based on conditions.
              const minCompare = (parseFloat(product.p_min_c) <= 0 || parseFloat(product.p_min_c) < parseFloat(product.p_min)) 
                ? product.p_min 
                : product.p_min_c;

              const maxCompare = (parseFloat(product.p_max_c) <= 0 || parseFloat(product.p_max_c) < parseFloat(product.p_max)) 
                ? product.p_max 
                : product.p_max_c;

              const comparePriceRangeText = `$${minCompare} - $${maxCompare}`;
              comparePriceSpan.innerText = comparePriceRangeText;
              comparePriceSpan.setAttribute('aria-label', `; price: ${comparePriceRangeText}`);
            }
          }
        }
      }

      if (product.hasOwnProperty('reviews_count') && product.reviews_count > 0) {
        if (element.querySelector('.yotpo')) {
          element.querySelector('.yotpo').remove();
        }
        if (element.querySelector('.yotpo-widget-instance')) {
          element.querySelector('.yotpo-widget-instance').remove();
        }
        let reviews = document.createElement('div');
        reviews.classList.add('yotpo');
        reviews.classList.add('bottomLine');
        reviews.dataset.productId = product.id;
        reviews.dataset.url = product.u;

        element.querySelector('.info').insertBefore(reviews, element.querySelector('.fs-product-title'));
        if (typeof yotpoWidgetsContainer != "undefined" && !element.querySelector('.yotpo-widget-instance')) {
          yotpoWidgetsContainer.initWidgets();
        }
        // Add observer for .info element modifications
        let infoElement = element.querySelector('.info');
        if (infoElement) {
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'childList' || mutation.type === 'subtree') {
                let bottomLineText = infoElement.querySelector('.yotpo-sr-bottom-line-text');
                if (bottomLineText) {
                  let text = bottomLineText.innerText.replace(' Reviews', '').trim();
                  if (!text.includes('(')) {
                    bottomLineText.innerHTML = '(' + text + ')';
                  }
                }
              }
            });
          });

          observer.observe(infoElement, {
            childList: true,
            subtree: true,
            characterData: true
          });
        }
      }

    });
  }

  /**
   * Updates the search page title with the search query if applicable. Also adjusts the product grid layout.
   *
   * @param {HTMLElement} element The HTML element from which the closest `.searchResultsWrapper` is determined.
   * @return {void} This method does not return any value.
   */
  updateSearchPageTitle(element) {
    // Update the search page title text
    let searchWrapper = element.closest('.searchResultsWrapper');
    if (searchWrapper) {
      let title = searchWrapper.querySelector('.titleWrapper .title');
      // Only do this once - if the title is already updated, don't do anything.
      if (title && title.innerText.toLowerCase().trim().includes('search results for') && !title.innerText.toLowerCase().trim().includes('"')) {
        const url = new URL(window.location.href);
        const searchQuery = url.searchParams.get('q');
        if (searchQuery) {
          title.innerText = `Search Results for "${searchQuery}"`;
        }
        title.closest('.titleWrapper').classList.add('show');
        let productGrid = searchWrapper.querySelector('.products-grid');
        if (productGrid) {
          productGrid.style.setProperty("--grid-template-columns", "repeat(4, 1fr)");
        }
      }
    }
  }

  /**
   * Updates the reviews count text for a product.
   *
   * @param {Object} product - The product object containing review information.
   * @param {number} product.reviewCount - The number of reviews for the product.
   * @param {HTMLElement} productElement - The DOM element representing the product.
   * @return {void} This method does not return any value.
   */
  updateReviewsCountText(product, productElement) {
    // Update the reviews count text
    if (product.hasOwnProperty('reviewCount') && product.reviewCount > 0) {
      let reviewAvgEl = productElement.querySelector('.fs-reviews-avg');
      if (reviewAvgEl && !reviewAvgEl.innerText.includes('(')) {
        reviewAvgEl.innerHTML = `<span class="fs-reviews-avg-el">(${reviewAvgEl.innerText})</span>`;
      }
      let reviewCountEl = productElement.querySelector('.fs-reviews-count');
      if (reviewCountEl && !reviewCountEl.innerText.includes('reviews')) {
        reviewCountEl.innerText = reviewCountEl.innerText.replace('(', '').replace(')', '') + ' reviews';
      }
    }
  }

  /**
   * Adds a compare price element to the product blocks on the page, handling the creation of necessary DOM elements
   * and updating pricing details in the global `fsProductPricing` object.
   *
   * @param {Object} product - An object containing product details such as the formatted price and compare price.
   * @param {string} productId - The unique identifier for the product to be updated.
   * @param {HTMLElement} productElement - The DOM element representing the product block on the page.
   * @return {void} This method does not return a value.
   */
  addComparePriceToProductBlocks(product, productId, productElement) {
    let _this = this;

    let b2bMultiplier = 1;
    if (typeof window.b2bMultiplier != 'undefined') {
      b2bMultiplier = parseFloat(window.b2bMultiplier);
    }

    // Add the compare price to product blocks if applicable
    if (typeof _this.fsProductPricing == "undefined" || !_this.fsProductPricing) {
      _this.fsProductPricing = {};
    }
    _this.fsProductPricing[`${productId}`] = {price: product.formattedPrice, element: productElement};
    if (!productElement.querySelector('.price-holder')) {
      let priceContainer = productElement.querySelector('.price-container.fs-serp-price');
      let compareContainer = productElement.querySelector('.compare-container');
      if (priceContainer) {
        let priceHolder = document.createElement("div");
        priceHolder.classList.add('price-holder');
        priceContainer.parentNode.insertBefore(priceHolder, priceContainer);
        priceHolder.appendChild(priceContainer);
        if (compareContainer) {
          priceHolder.appendChild(compareContainer);
        }
      }
    }
    let compareEl = productElement.querySelector('.compare.fs-compare');
    if (compareEl) {
      let comparePrice = `$${product.comparePrice * b2bMultiplier}`;
      let maxComparePrice = `$${product.maxCompare * b2bMultiplier}`;
      compareEl.innerText = comparePrice;
      if (maxComparePrice && product.maxCompare > 0 && maxComparePrice !== comparePrice) {
        compareEl.innerText += ` - ${maxComparePrice}`;
      }
      _this.fsProductPricing[`${productId}`].compareText = compareEl.innerText;
    }
  }

  /**
   * Adds a monogram icon to the specified product element if the product matches the monogram tag set in the global window object.
   * The monogram icon will display a tooltip when clicked, showing additional descriptive text defined in the global configuration.
   *
   * @param {Object} product - The product object to check for matching tags.
   * @param {HTMLElement} productElement - The HTML element associated with the product where the icon will be added.
   * @return {void} No value is returned. The function modifies the DOM to add the monogram icon if conditions are met.
   */
  addMonogramIcon(product, productElement) {
    if (typeof window.productMonogramTag != "undefined" &&
      typeof window.productMonogramIcon != "undefined") {

      let iconHoverText = window.productMonogramIconHoverText;

      let hasTag = product?.tags?.find(tag => {
        return tag.toLowerCase() === window.productMonogramTag.toLowerCase();
      })

      if (hasTag) {
        let target = productElement.querySelector('.info-container .price-holder');

        if (target && !target.querySelector('.monogram-icon')) {
          let titlewrapper = productElement.querySelector('.info-container .fs-product-title-wrapper');

          let iconContainer = document.createElement('div');
          iconContainer.classList.add('monogram-icon-container');

          iconContainer.innerHTML = `<div class="monogram-inner-container">
            <img class="monogram-icon" src="${window.productMonogramIcon}" alt="${iconHoverText}"/>
            <div class="monogram-tooltip">${iconHoverText}</div>
            </div>`

          let icon = iconContainer.querySelector('.monogram-icon');
          icon.addEventListener('click', (e) => {
            let tooltipContainer = icon.closest('.monogram-inner-container');

            if (tooltipContainer) {
              tooltipContainer.classList.toggle('active');
            }
          });

          target.appendChild(iconContainer);
          titlewrapper.classList.add('has-monogram');

          setTimeout(() => {
            let titleHeight = titlewrapper.offsetHeight;
            productElement.querySelector('.monogram-icon-container').style.setProperty('top', `-${titleHeight}px`);
          },1);
        }
      }
    }
  }

  clearTooltips(element) {
    element.querySelectorAll('.monogram-inner-container.active').forEach(tooltip => {
      tooltip.classList.remove('active');
    });
  }

  /**
   * Processes and formats customer tags by removing unwanted tags, normalizing them,
   * and determining the customer's tier name based on specific tag conditions.
   * Updates the `tagsString` and `tiername` properties of `customerData`.
   *
   * @return {void} This method does not return a value. It modifies the properties of `customerData` in place.
   */
  formatTags() {
    if (!this.customerData.loggedIn) return;

    const tags = Array.isArray(this.customerData.tags) ? this.customerData.tags : [];

    // Filter out "test" (case-insensitive)
    const cleanTags = tags.filter(tag => tag.toLowerCase() !== 'test');

    // Join remaining tags with spaces
    this.customerData.tagsString = cleanTags.join(' ');

    // Normalize tags for case-insensitive comparison
    const lowerTags = cleanTags.map(tag => tag.toLowerCase());

    // Determine tier name based on tag presence
    if (lowerTags.includes('wholesale')) {
      this.customerData.tiername = 'Wholesale';
    } else if (lowerTags.includes('trade elite') || lowerTags.includes('elite')) {
      this.customerData.tiername = 'Trade Elite';
    } else if (lowerTags.includes('trade')) {
      this.customerData.tiername = 'Trade';
    }
  }

  /**
   * Updates the price and compare price elements within a product element, optionally adding tier-based pricing or retail displays.
   * This method dynamically modifies DOM elements to reflect new pricing structures, including trade and retail tiers.
   *
   * @param {HTMLElement} productElement - The root HTML element for the product where prices should be updated.
   * @param {number} lowestPrice - The lowest price value for the product.
   * @param {number} highestPrice - The highest price value for the product, may be null or 0.
   * @param {number} lowestCompare - The lowest compare price value for the product, used to display original/retail pricing.
   * @param {number} highestCompare - The highest compare price value for the product, may be null or 0.
   * @param {string} pId - The unique identifier for the product.
   * @param {string|null} [tiername=null] - The name of the pricing tier to display, such as trade pricing. Defaults to null.
   * @return {void} This method does not return any value; it directly updates the DOM elements.
   */
  setNewPrice(productElement, lowestPrice, highestPrice, lowestCompare, highestCompare, pId, tiername = null) {
    const priceElement = productElement.querySelector('.price, .fs-price');
    const compareElement = productElement.querySelector('.compare, .fs-price.compare');
    const basePrice = productElement.querySelector('.price');

    // --- Hide compare element if it exists ---
    if (compareElement) {
      compareElement.style.display = 'none';
    }

    const highestPriceString = highestPrice && highestPrice > 0 && highestPrice != lowestPrice ? ` - $${highestPrice}` : '';
    const highestCompareString = highestCompare && highestCompare > 0 && highestCompare != lowestCompare ? ` - $${highestCompare}` : '';

    // --- Add Trade price only if it doesn't already exist ---
    if (tiername && lowestPrice && priceElement && !productElement.querySelector('.trade.price')) {
      // Capitalize tiername (first letter uppercase, rest lowercase)
      const tierDisplay =
        tiername && typeof tiername === 'string'
          ? tiername.charAt(0).toUpperCase() + tiername.slice(1).toLowerCase()
          : '';

      const tradeHtml = `
      <div class="trade price">
        <span>
          $${lowestPrice}${highestPriceString}
          <span style="letter-spacing:0; font-size:11px; vertical-align:unset;">${tierDisplay}</span>
        </span>
      </div>`;

      priceElement.insertAdjacentHTML('afterend', tradeHtml);
    }

    // --- Add Retail compare only if it doesn't already exist ---
    if (lowestCompare && !productElement.querySelector('.retail.compare')) {
      basePrice.parentNode.classList.add('has-compare');

      const retailHtml = `
      <div class="retail compare">
        <span>
          $${lowestCompare}${highestCompareString}
          <span class="${tiername ? '' : 'hidden'}" style="letter-spacing:0; font-size:11px; vertical-align:unset;">Retail</span>
        </span>
      </div>`;
      // Insert after hidden compare element if it existed
      if (compareElement) {
        compareElement.insertAdjacentHTML('afterend', retailHtml);
      } else if (priceElement) {
        priceElement.insertAdjacentHTML('afterend', retailHtml);
      }
    }

    // --- Modify base price ---
    if (basePrice) {

      let b2bMultiplier = 1;
      if (typeof window.b2bMultiplier != 'undefined') {
        b2bMultiplier = parseFloat(window.b2bMultiplier);
        basePrice.closest('.price-holder').classList.add('has-b2b-pricing');
      }

      let b2bPrice = (lowestPrice * b2bMultiplier).toFixed(2);
      let b2bPriceString = `$${b2bPrice}`;
      if (highestPrice > 0) {
        let highestB2bPrice = (highestPrice * b2bMultiplier).toFixed(2);
        b2bPriceString += highestB2bPrice > 0 && highestB2bPrice != b2bPrice ? ` - $${highestB2bPrice}` : '';
      }

      basePrice.innerHTML = `${b2bPriceString}`;

      // --- Add "Retail" label inside main price (only once) ---
      if (!basePrice.querySelector('.inline-retail')) {
        basePrice.insertAdjacentHTML(
          'beforeend',
          `<span class="${tiername ? '' : 'hidden '}inline-retail" style="letter-spacing:0; font-size:11px; vertical-align:unset; margin-left:4px;">Retail</span>`
        );
      }
      basePrice.classList.add('retail');
    }
  }

  /**
   * Updates a product element's price display using special pricing obtained from JSON data fetched based on the product URL.
   *
   * @param {HTMLElement} productElement - The DOM element representing the product where the special price will be displayed.
   * @param {string|number} pId - The unique product identifier to reference the product data in the `window.pdpData` object.
   * @param {string} productURL - The URL used to fetch the product's JSON data containing pricing details.
   * @param {string|null} [tiername=null] - An optional parameter used to handle pricing tiers (if applicable).
   * @return {void} Does not return a value. Modifies the `productElement` directly or hides it if an error occurs.
   */
  async setProductSpecialPrice(productElement, pId, productURL, tiername = null) {
    let _this = this;
    const country = Shopify?.country;
    if (!productURL || !productElement) return;

    const splattedURL = productURL.split('?');

    try {
      if (window.pdpData[pId] && window.pdpData[pId] === "notFetched") {
        const fullURL = `${splattedURL[0]}.json${splattedURL?.[1] ? `?${splattedURL[1]}` : ''}`;

        const res = await fetch(fullURL, { cache: 'no-store' });
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }

        // Read as text first to handle empty/invalid JSON safely
        const text = await res.text();
        if (!text) {
          throw new Error('Empty response body');
        }

        let data;
        try {
          data = JSON.parse(text);
        } catch (e) {
          throw new Error('Invalid JSON in response');
        }

        if (!data?.product) throw new Error('Missing product field');
        window.pdpData[pId] = data.product;
      }

      if (window.pdpData[pId] && window.pdpData[pId] !== "notFetched" && window.pdpData[pId] !== "404") {
        const product = window.pdpData[pId];

        const variantID = productURL
          .split('&')
          .find(param => param.includes('variant'))
          ?.split('=')?.[1];

        let lowestPriceVariant = product.variants.reduce((min, v) => parseFloat(v.price) < parseFloat(min.price) ? v : min, product.variants[0]);
        let highestPriceVariant = product.variants.reduce((max, v) => parseFloat(v.price) > parseFloat(max.price) ? v : max, product.variants[0]);

        const variant = product.variants.find(v => v.id === Number(variantID)) ||
          lowestPriceVariant;

        if (variant) {
          const lowestPrice = lowestPriceVariant?.price ?? 0;
          const highestPrice = highestPriceVariant?.price ?? 0;
          const lowestCompare = parseFloat(lowestPriceVariant?.compare_at_price) > 0.0 ? lowestPriceVariant?.compare_at_price : null;
          let highestCompare = parseFloat(highestPriceVariant?.compare_at_price) > 0.0 ? highestPriceVariant?.compare_at_price : null;

          if (!highestCompare && lowestCompare && highestPrice > 0) {
            highestCompare = highestPrice;
          }

          _this.setNewPrice(productElement, lowestPrice, highestPrice, lowestCompare, highestCompare, pId, tiername);
        }
      }
    } catch (err) {
      //console.error('setProductSpecialPrice error:', err);
      // Hide the product tile when JSON fetch/parse fails
      productElement.style.display = 'none';
      // Optional: mark as failed so we don't retry endlessly on this render
      window.pdpData[pId] = err.message.includes('404') ? '404' : "notFetched";
      return;
    }
  }

  /**
   * Adds a sale tag to a product's element, fetching the tag data asynchronously and ensuring it is updated in the DOM.
   *
   * @param {Object} product - The product object containing details such as the product URL.
   * @param {string} productId - The unique identifier of the product.
   * @param {HTMLElement} productElement - The HTML element representing the product in the DOM.
   * @return {void} This method does not return a value.
   */
  addSaleTag(product, productId, productElement) {
    let _this = this;
    // Sale Tag

    if (window.pdpData[productId] == '404') return;

    // Add holder for after color swatches if not exists
    if (!productElement.querySelector('.after-color-swatches-wrapper')) {
      let elementHolder = document.createElement("div");
      elementHolder.classList.add('after-color-swatches-wrapper');

      let infoContainer = productElement.querySelector('.info-container');
      if (infoContainer) {
        infoContainer.appendChild(elementHolder);
      }
    }

    // Remove existing sale-tag-fetched class to allow re-fetching if needed
    if (productElement.classList.contains('sale-tag-fetched')) {
      productElement.classList.remove('sale-tag-fetched');

      // clear window.fetchingSaleTag
      _this.fetchingSaleTag[productId] = false;
    }

    // Fetch URL
    let fetchUrl = product.productURL + '?view=product_data';

    // Ensure global tracker exists
    _this.fetchingSaleTag = _this.fetchingSaleTag || {};

    // Only run if not fetched or fetching yet
    if (
      product.productURL &&
      !productElement.classList.contains('sale-tag-fetched') &&
      !_this.fetchingSaleTag[productId]
    ) {
      // Mark as fetching immediately to prevent duplicates
      _this.fetchingSaleTag[productId] = true;

      fetch(fetchUrl)
        .then(response => response.json())
        .then(data => {
          // Mark as fetched (only once)
          productElement.classList.add('sale-tag-fetched');

          if (data.sale_tag) {
            // Decode and append HTML safely
            let tempDiv = document.createElement('div');
            tempDiv.innerHTML = data.sale_tag;
            let decodedHTML = tempDiv.textContent || tempDiv.innerText;

            if (decodedHTML) {
              let infoContainer = productElement.querySelector('.after-color-swatches-wrapper');
              if (infoContainer) {
                infoContainer.innerHTML = decodedHTML;
              }
            }
          }
        })
        .catch(error => {
          console.error('Error fetching product data:', error);
        })
        .finally(() => {
          // Mark as complete (optional cleanup)
          _this.fetchingSaleTag[productId] = false;
        });
    }
  }

}

let fsCustom = new FSCustom();
fsCustom.init();